import React from "react";
import { PROMISES, TESTIMONIALS, MARQUEE_ITEMS } from "@/mock";
import { Star, Sparkles, ShieldCheck, Truck, RotateCcw } from "lucide-react";

const iconMap = [Sparkles, ShieldCheck, Truck, RotateCcw];

export const StripMarquee = () => {
  const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div className="bg-[#111112] text-[#e9d9b0] text-[12px] uppercase tracking-[0.25em] overflow-hidden border-y border-[#1c1c1e]">
      <div className="flex whitespace-nowrap py-4">
        <div className="flex animate-[marquee2_40s_linear_infinite] gap-16 px-8">
          {items.map((t, i) => (
            <span key={i} className="inline-flex items-center gap-3">
              <span className="h-1 w-1 rounded-full bg-[#c9a24a]" />
              {t}
            </span>
          ))}
        </div>
      </div>
      <style>{`@keyframes marquee2 { from{transform:translateX(0);} to{transform:translateX(-50%);} }`}</style>
    </div>
  );
};

export const Promises = () => (
  <section className="bg-[#0b0b0c] py-24 border-t border-[#1c1c1e]">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
      <div className="flex items-end justify-between mb-12">
        <div>
          <div className="text-[#c9a24a] uppercase text-[11px] tracking-[0.4em] mb-4">
            Why Jhumar
          </div>
          <h2 className="font-serif text-[#f4ead5] text-4xl md:text-5xl">
            Simple promises, <span className="italic">kept</span>
          </h2>
        </div>
        <a
          href="#about"
          className="hidden md:inline-block text-[#e9d9b0] hover:text-[#c9a24a] text-sm transition-colors"
        >
          Our story →
        </a>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
        {PROMISES.map((p, i) => {
          const Icon = iconMap[i];
          return (
            <div
              key={p.title}
              className="group border border-[#1c1c1e] hover:border-[#c9a24a]/50 bg-[#111112] p-7 transition-colors"
            >
              <div className="w-11 h-11 flex items-center justify-center border border-[#2a2724] text-[#c9a24a] group-hover:border-[#c9a24a] transition-colors">
                <Icon size={18} />
              </div>
              <div className="font-serif text-[#f4ead5] text-xl mt-6">{p.title}</div>
              <div className="text-[#a9a294] text-sm mt-3 leading-relaxed">{p.body}</div>
            </div>
          );
        })}
      </div>
    </div>
  </section>
);

export const Testimonials = () => (
  <section className="bg-[#0b0b0c] py-24 border-t border-[#1c1c1e]">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
      <div className="mb-12">
        <div className="text-[#c9a24a] uppercase text-[11px] tracking-[0.4em] mb-4">
          In their words
        </div>
        <h2 className="font-serif text-[#f4ead5] text-4xl md:text-5xl">
          Loved and <span className="italic">lit</span>
        </h2>
      </div>

      <div className="grid md:grid-cols-3 gap-6">
        {TESTIMONIALS.map((t) => (
          <div
            key={t.name}
            className="border border-[#1c1c1e] bg-[#111112] p-7 hover:border-[#c9a24a]/50 transition-colors"
          >
            <div className="flex gap-1 text-[#c9a24a]">
              {[...Array(5)].map((_, i) => (
                <Star key={i} size={14} fill="#c9a24a" strokeWidth={0} />
              ))}
            </div>
            <p className="text-[#e9d9b0] text-[15px] mt-5 leading-relaxed">
              “{t.body}”
            </p>
            <div className="flex items-center gap-3 mt-6 pt-5 border-t border-[#2a2724]">
              <div className="w-9 h-9 rounded-full bg-[#c9a24a]/15 border border-[#c9a24a]/40 flex items-center justify-center text-[#c9a24a] text-sm font-medium">
                {t.initial}
              </div>
              <div>
                <div className="text-[#f4ead5] text-sm">{t.name}</div>
                <div className="text-[#a9a294] text-xs">{t.city}</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);
